import { createContext } from 'react';

export interface RealtimeContextValue {
  subscribe: (event: string, handler: (...args: unknown[]) => void) => () => void;
  emit: (event: string, payload?: unknown) => void;
  /** False while the socket is down — live updates are not arriving and the UI should say so. */
  isConnected: boolean;
}

export const RealtimeContext = createContext<RealtimeContextValue | null>(null);
